class HeartOfOliveProductCarousel extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;

    this.track = this.querySelector('[data-carousel-track]');
    this.previousButton = this.querySelector('[data-carousel-previous]');
    this.nextButton = this.querySelector('[data-carousel-next]');
    if (!this.track || !this.previousButton || !this.nextButton) return;

    this.dataset.ready = 'true';
    this.dragging = false;
    this.dragMoved = false;
    this.suppressClick = false;
    this.pointerId = null;
    this.startX = 0;
    this.startScrollLeft = 0;

    this.previousButton.addEventListener('click', () => this.move(-1));
    this.nextButton.addEventListener('click', () => this.move(1));
    this.track.addEventListener('scroll', () => this.queueUpdate(), { passive: true });
    this.track.addEventListener('keydown', (event) => this.onKeydown(event));
    this.track.addEventListener('pointerdown', (event) => this.onPointerDown(event));
    this.track.addEventListener('pointermove', (event) => this.onPointerMove(event));
    this.track.addEventListener('pointerup', (event) => this.onPointerUp(event));
    this.track.addEventListener('pointercancel', (event) => this.onPointerUp(event));
    this.track.addEventListener('click', (event) => this.onClick(event), true);
    this.track.addEventListener('dragstart', (event) => event.preventDefault());

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(() => this.updateButtons());
      this.resizeObserver.observe(this.track);
    } else {
      window.addEventListener('resize', () => this.updateButtons(), { passive: true });
    }
    requestAnimationFrame(() => this.updateButtons());
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  move(direction) {
    const distance = Math.max(this.track.clientWidth * 0.82, 280);
    this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
  }

  onKeydown(event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    this.move(event.key === 'ArrowLeft' ? -1 : 1);
  }

  onPointerDown(event) {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    if (event.target.closest('button, input, textarea, select')) return;

    this.dragging = true;
    this.dragMoved = false;
    this.suppressClick = false;
    this.pointerId = event.pointerId;
    this.startX = event.clientX;
    this.startScrollLeft = this.track.scrollLeft;
  }

  onPointerMove(event) {
    if (!this.dragging || event.pointerId !== this.pointerId) return;
    const distance = event.clientX - this.startX;

    if (!this.dragMoved && Math.abs(distance) <= 7) return;

    if (!this.dragMoved) {
      this.dragMoved = true;
      this.track.setPointerCapture(event.pointerId);
      this.track.classList.add('is-dragging');
    }

    event.preventDefault();
    this.track.scrollLeft = this.startScrollLeft - distance;
  }

  onPointerUp(event) {
    if (!this.dragging || event.pointerId !== this.pointerId) return;
    const didMove = this.dragMoved;

    this.dragging = false;
    if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
    this.track.classList.remove('is-dragging');
    this.pointerId = null;
    this.dragMoved = false;

    if (didMove) {
      this.suppressClick = true;
      this.queueUpdate();
      window.setTimeout(() => { this.suppressClick = false; }, 100);
    }
  }

  onClick(event) {
    if (!this.suppressClick) return;
    event.preventDefault();
    event.stopPropagation();
    this.suppressClick = false;
  }

  queueUpdate() {
    cancelAnimationFrame(this.updateFrame);
    this.updateFrame = requestAnimationFrame(() => this.updateButtons());
  }

  updateButtons() {
    const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    this.previousButton.disabled = this.track.scrollLeft <= 2;
    this.nextButton.disabled = this.track.scrollLeft >= maximum - 2;
  }
}

if (!customElements.get('hoo-product-carousel')) {
  customElements.define('hoo-product-carousel', HeartOfOliveProductCarousel);
}
